import moment from 'moment';

import {BasicPlanLimit} from '../models/basic-plan-limit.model';

const DISPLAY_FORMAT = 'MMM D, YYYY';

/**
 * Basic credits count per subscription term (CU-868mma4rf). termEnd is the renewal date, an ISO
 * date. It is parsed as a local date, because new Date('YYYY-MM-DD') is UTC and shows the day
 * before in US time zones.
 */
function renewalDate(entitlement?: BasicPlanLimit): moment.Moment | undefined {
  if (!entitlement?.termEnd) {
    return undefined;
  }
  const renewal = moment(entitlement.termEnd, 'YYYY-MM-DD', true);
  return renewal.isValid() ? renewal : undefined;
}

/** The last day of the current term, for example "Feb 28, 2027". */
export function basicTermLastDay(entitlement?: BasicPlanLimit): string | undefined {
  return renewalDate(entitlement)?.subtract(1, 'day').format(DISPLAY_FORMAT);
}

/** The day the credits reset, which is the renewal date, for example "Mar 1, 2027". */
export function basicTermResetDate(entitlement?: BasicPlanLimit): string | undefined {
  return renewalDate(entitlement)?.format(DISPLAY_FORMAT);
}

/**
 * The message for a Basic firm at or over its plan limit, for example "Your firm already has 13 plans
 * this subscription term. Your credits reset on Feb 2, 2027. Use the Upgrade link below the plan
 * counter to request an upgrade."
 */
export function basicLimitReachedMessage(entitlement: BasicPlanLimit): string {
  const resetDate = basicTermResetDate(entitlement);
  const reset = resetDate ? ` Your credits reset on ${resetDate}.` : '';
  return `Your firm already has ${entitlement.used} plans this subscription term.${reset}`
    + ' Use the Upgrade link below the plan counter to request an upgrade.';
}
